// Cada bloque termina siendo texto: el editor es un <textarea>, asi que
// insertar un bloque es insertar texto. `select` es el placeholder que queda
// seleccionado despues de insertar, para sobreescribirlo tipeando. Los bloques
// con `prompt` no insertan nada directo: abren un formulario y el texto se arma
// con lo que llene el tenant, para que no tenga que escribir la sintaxis.
export const EDITOR_BLOCKS = [
    {
        key: "heading",
        label: "Encabezado",
        detail: "Título de sección",
        snippet: {
            text: "## Título de la sección",
            select: "Título de la sección",
            block: true
        }
    },
    {
        key: "bulletList",
        label: "Lista",
        detail: "Lista con viñetas",
        snippet: {
            text: "- Primer punto\n- Segundo punto",
            select: "Primer punto",
            block: true
        }
    },
    {
        key: "blockquote",
        label: "Cita",
        detail: "Bloque de cita",
        snippet: {
            text: "> Cita o testimonio",
            select: "Cita o testimonio",
            block: true
        }
    },
    {
        key: "codeBlock",
        label: "Código",
        detail: "Bloque de código",
        snippet: {
            text: "```\ncódigo\n```",
            select: "código",
            block: true
        }
    },
    {
        key: "image",
        label: "Imagen",
        detail: "Imagen con tamaño, alineación y enlace",
        prompt: "image"
    },
    {
        key: "table",
        label: "Tabla",
        detail: "Llenar una tabla sin escribir markdown",
        prompt: "table"
    },
    {
        key: "cta",
        label: "CTA",
        detail: "Botón de llamada a la acción",
        prompt: "cta"
    },
    {
        key: "callout",
        label: "Callout",
        detail: "Caja de aviso o destacado",
        snippet: {
            text: ":::callout\nTexto destacado\n:::",
            select: "Texto destacado",
            block: true
        }
    },
    {
        key: "embed",
        label: "Embed",
        detail: "Video de TikTok o YouTube",
        prompt: "embed"
    }
];

export const URL_PATTERN = /^https?:\/\/\S+$/;

export function buildCtaSnippet({ label, url }) {
    return { text: `:::cta ${label}|${url}\n:::`, block: true };
}

export function buildEmbedSnippet({ url }) {
    return { text: `:::embed ${url}\n:::`, block: true };
}

function normalize(value) {
    return value.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
}

export function filterBlocks(query) {
    const typed = normalize(query || "");
    if (!typed) return EDITOR_BLOCKS;
    return EDITOR_BLOCKS.filter((block) =>
        normalize(block.label).startsWith(typed)
    );
}
